import Funnel from "@mapmycustomers/shared/types/entity/deals/Funnel";
import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";

import { getLayoutsForEntity } from "@app/store/layout";
import { DealFieldName } from "@app/util/fieldModel/DealFieldModel";
import getActualLayoutSchema from "@app/util/layout/getActualLayoutSchema";

// Required-ness of the loss fields is a property of the funnel's layout for the destination stage,
// not of the proposal — which is why it is read per {funnelId, stageId} rather than once per card.
export const getLossFieldRequirements = (
  layouts: ReturnType<typeof getLayoutsForEntity>,
  funnelId: Funnel["id"],
  stageId: Stage["id"] | undefined
): { commentRequired: boolean; reasonRequired: boolean } => {
  if (stageId === undefined) {
    return { commentRequired: false, reasonRequired: false };
  }
  const variant = { funnelId, stageId };
  const required = (field: string) =>
    layouts.some(
      (layout) =>
        getActualLayoutSchema(layout, variant).find((schemaField) => schemaField.field === field)
          ?.required
    );
  return {
    commentRequired: required(DealFieldName.DEAL_LOSS_COMMENT),
    reasonRequired: required("dealLossReasonId"),
  };
};
